<template>
  <Multiselect
    :value="selectedColor"
    :class="['asd-multiselect']"
    :options="colors"
    :searchable="false"
    :allowEmpty="false"
    trackBy="name"
    label="name"
    selectLabel="Vyberte zmáčknutím enteru"
    selectGroupLabel="Vyberte skupinu zmáčknutím enteru"
    selectedLabel="Vybráno"
    deselectLabel="Odeberte zmáčknutím enteru"
    deselectGroupLabel="Odeberte skupinu zmáčknutím enteru"
    placeholder="Vyberte barvu"
    @input="onInput"
  >
    <template slot="singleLabel" slot-scope="{ option }">
      <span class="color-square" :style="{'backgroundColor': option.code}"></span> {{ option.name }}
    </template>

    <template slot="option" slot-scope="{ option }">
      <span class="color-square--list" :style="{'backgroundColor': option.code}"></span> {{ option.name }}
    </template>
  </Multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'
import colors from 'ENUMS/colors'
import { get, head, filter } from 'lodash'

export default {
    name: 'ColorInput',
    components: {
        Multiselect,
    },
    props: {
        value: {
            type: String,
            required: false,
            default: _ => null,
        },
        colorListOverride: {
            type: Array,
            required: false,
            default: _ => null,
        },
    },
    computed: {
        colors() {
            if (this.colorListOverride === null) {
                return colors
            } else {
                return this.colorListOverride
            }
        },
        selectedColor() {
            return head(filter(this.colors, { code: this.value }))
        },
    },
    methods: {
        onInput(e) {
            this.$emit('input', get(e, 'code', null))
        },
    },
}
</script>
<style lang="scss" scoped>
.color-square {
    width: 20px;
    height: 20px;
    display: inline-block;
    border-radius: 3px;
    margin: 0;
    transform: translate(-2px,-2px);
}
.color-square--list {
    width: 20px;
    height: 20px;
    border-radius: 3px;
    display: inline-block;
    transform: translateY(3px);
}
</style>


